import HttpService from "../../../services/HttpService";

export interface ISegItem {
    id: string;
    name: string;
    city: string;
    state: string;
}

export async function getSegs({query, limit = 10}) {
    const response = await HttpService.get<ISegItem[]>(`${process.env.GATSBY_API_URL}/segs?searchQuery=${encodeURIComponent(query)}&itemsPerPage=${limit}`);
    return response.map(item => ({
        key: item.id,
        title: item.name,
    }))
}
